import { useQuery } from "@tanstack/react-query";
import * as chatbotApi from "src/api/chatbot";
import type { ChatbotInstructions } from "src/components/GlobalChatbot/types";
import { chatbotQueryKeys } from "src/hooks/chatbotQueryKeys";
import defaultOptions from "src/hooks/defaultOptions";

export function useChatbotInstructions() {
	return useQuery<ChatbotInstructions>({
		queryKey: chatbotQueryKeys.instructions,
		queryFn: chatbotApi.getChatbotInstructions,
		...defaultOptions,
		staleTime: Infinity,
	});
}
